import { render } from "./DeleteButton.vue?vue&type=template&id=a7bc1e4e&ts=true"
import script from "./DeleteButton.vue?vue&type=script&lang=ts"
export * from "./DeleteButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__